module.exports = __webpack_public_path__ + "media/images/admin/icons/printer-64cd3316a4534126358711d946e9eeef.svg";